import React from "react";
import StreamCursor from "./StreamCursor";

function withCursor(text, show) {
  if (!show) return text;
  return (
    <>
      {text}
      <StreamCursor active />
    </>
  );
}

/** Render partially streamed tokens inside nl-response-html. */
export default function StreamingStructuredBody({ tokens, isStreaming }) {
  if (isStreaming && tokens.length === 0) {
    return (
      <div className="nl-response-html">
        <div className="nl-research-skeleton" aria-hidden="true">
          <span className="nl-sk-line" />
          <span className="nl-sk-line nl-sk-short" />
          <span className="nl-sk-line" />
        </div>
      </div>
    );
  }

  const elements = [];
  let bulletGroup = null;
  const last = tokens[tokens.length - 1];

  const flushBullets = () => {
    if (!bulletGroup?.length) return;
    elements.push(
      <ul key={`ul-${elements.length}`}>
        {bulletGroup.map((bullet, bi) => (
          <li key={`${bi}-${bullet.slice(0, 20)}`}>
            {withCursor(
              bullet,
              isStreaming &&
                last?.type === "li" &&
                bullet === last.text &&
                bi === bulletGroup.length - 1,
            )}
          </li>
        ))}
      </ul>,
    );
    bulletGroup = null;
  };

  tokens.forEach((token, i) => {
    if (!token?.text && token?.text !== "") return;
    if (token.type === "h3") {
      flushBullets();
      elements.push(
        <h3 key={`h3-${i}`}>
          {withCursor(token.text, isStreaming && last === token)}
        </h3>,
      );
    } else if (token.type === "h5") {
      flushBullets();
      elements.push(
        <h5 key={`h5-${i}`} className="nl-debate-arg-heading">
          {withCursor(token.text, isStreaming && last === token)}
        </h5>,
      );
    } else if (token.type === "li") {
      if (!bulletGroup) bulletGroup = [];
      bulletGroup.push(token.text);
    }
  });
  flushBullets();

  return <div className="nl-response-html">{elements}</div>;
}
